import { gql } from '@apollo/client';
import checkpointReappraisalRationaleReviewFragment from './checkpointReappraisalRationaleReviewFragment';

const UPDATE_CHECKPOINT_REAPPRAISAL_RATIONALE_REVIEW = gql`
  mutation UpdateCheckpointReappraisalRationaleReview(
    $review: CheckpointReappraisalRationaleReviewInput!
  ) {
    updateCheckPointReappraisalRationaleReview(review: $review) {
      ...CheckpointReappraisalRationaleReviewFields
    }
  }
  ${checkpointReappraisalRationaleReviewFragment}
`;

export default UPDATE_CHECKPOINT_REAPPRAISAL_RATIONALE_REVIEW;
